module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#text",
      toString: function () {
        return this.url;
      }
    }